import axios from "axios";
const API_BASE_URL = "http://localhost:5001/api"; // Update with your actual API URL

export const getManageUser1 = async (searchTerm, page, limit) => {
  try {
    // const response = await axios.get(`${API_BASE_URL}/sales/products`);
    // return response.data;
    const response = {
      success: true,
      message: "Sales products fetched successfully",
      data: {
        items: [
          {
            patientnumber: "9921262361",
            quantity: "1",
            product_name: "1635543000001503688",
            dates: "2025-03-31",
            distributor_name: "Om Sai Healthcare",
            timestamp: "2025-03-31T04:32:40.946346",
            unit_price: "4300",
            record_id: "343275000030960001",
            sales_order_status: "Pending",
            product_code: "Econ Hinged Knee AM OB WA M",
            sales_record_id: "343275000030937017",
            patientemail: "",
            product_id: "1635543000001310603",
            UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
            nickname: "Ravindra Kumarprajapati",
            tracking_status: "Sale",
            category: "sales tracking",
            doctors_name: "343275000004035060",
            username: "ravindrakumarprajapati",
            doctorsname: "Sachin Tapasvi",
            group_title: "Distributor",
            patientname: "Vaibhav Kale ",
            Name: "2025-03-31 10:02:34 AM",
            product_group: "Economy Hinged Knee Brace",
          },
          {
            patientnumber: "9422008826",
            quantity: "1",
            product_name: "1635543000001492005",
            dates: "2025-03-31",
            distributor_name: "Om Sai Healthcare",
            timestamp: "2025-03-31T04:34:37.488234",
            unit_price: "13500",
            record_id: "343275000030898049",
            sales_order_status: "Pending",
            product_code: "Freestyle OA Med RT M",
            sales_record_id: "343275000030935012",
            patientemail: "",
            product_id: "1635543000001313306",
            UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
            nickname: "Ravindra Kumarprajapati",
            tracking_status: "Sale",
            category: "sales tracking",
            doctors_name: "343275000004035060",
            username: "ravindrakumarprajapati",
            doctorsname: "Sachin Tapasvi",
            group_title: "Distributor",
            patientname: "Dr. Vidya Gaikawad ",
            Name: "2025-03-31 10:04:32 AM",
            product_group: "Freestyle® OA Knee Brace",
          },
          {
            patientnumber: "9420558773",
            quantity: "1",
            product_name: "1635543000001506081",
            dates: "2025-03-31",
            distributor_name: "Om Sai Healthcare",
            timestamp: "2025-03-31T04:35:32.684273",
            unit_price: "12200",
            record_id: "343275000030953022",
            sales_order_status: "Pending",
            product_code: "Z-13 STD CI RT, S",
            sales_record_id: "343275000030945028",
            patientemail: "a@gmail.com",
            product_id: "1635543000001332616",
            UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
            nickname: "Ravindra Kumarprajapati",
            tracking_status: "Sale",
            category: "sales tracking",
            doctors_name: "343275000004035060",
            username: "ravindrakumarprajapati",
            doctorsname: "Sachin Tapasvi",
            group_title: "Distributor",
            patientname: "Dr.Renuka Manish Agarwal ",
            Name: "2025-03-31 10:05:28 AM",
            product_group: "Ligament Brace",
          },
          {
            patientnumber: "9921262361",
            quantity: "1",
            product_name: "1635543000001503688",
            dates: "2025-03-31",
            distributor_name: "Om Sai Healthcare",
            timestamp: "2025-03-31T04:32:40.946346",
            unit_price: "4300",
            record_id: "343275000030960001",
            sales_order_status: "Pending",
            product_code: "Econ Hinged Knee AM OB WA M",
            sales_record_id: "343275000030937017",
            patientemail: "",
            product_id: "1635543000001310603",
            UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
            nickname: "Ravindra Kumarprajapati",
            tracking_status: "Sale",
            category: "sales tracking",
            doctors_name: "343275000004035060",
            username: "ravindrakumarprajapati",
            doctorsname: "Sachin Tapasvi",
            group_title: "Distributor",
            patientname: "Vaibhav Kale ",
            Name: "2025-03-31 10:02:34 AM",
            product_group: "Economy Hinged Knee Brace",
          },
          {
            patientnumber: "9422008826",
            quantity: "1",
            product_name: "1635543000001492005",
            dates: "2025-03-31",
            distributor_name: "Om Sai Healthcare",
            timestamp: "2025-03-31T04:34:37.488234",
            unit_price: "13500",
            record_id: "343275000030898049",
            sales_order_status: "Pending",
            product_code: "Freestyle OA Med RT M",
            sales_record_id: "343275000030935012",
            patientemail: "",
            product_id: "1635543000001313306",
            UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
            nickname: "Ravindra Kumarprajapati",
            tracking_status: "Sale",
            category: "sales tracking",
            doctors_name: "343275000004035060",
            username: "ravindrakumarprajapati",
            doctorsname: "Sachin Tapasvi",
            group_title: "Distributor",
            patientname: "Dr. Vidya Gaikawad ",
            Name: "2025-03-31 10:04:32 AM",
            product_group: "Freestyle® OA Knee Brace",
          },
          {
            patientnumber: "9420558773",
            quantity: "1",
            product_name: "1635543000001506081",
            dates: "2025-03-31",
            distributor_name: "Om Sai Healthcare",
            timestamp: "2025-03-31T04:35:32.684273",
            unit_price: "12200",
            record_id: "343275000030953022",
            sales_order_status: "Pending",
            product_code: "Z-13 STD CI RT, S",
            sales_record_id: "343275000030945028",
            patientemail: "a@gmail.com",
            product_id: "1635543000001332616",
            UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
            nickname: "Ravindra Kumarprajapati",
            tracking_status: "Sale",
            category: "sales tracking",
            doctors_name: "343275000004035060",
            username: "ravindrakumarprajapati",
            doctorsname: "Sachin Tapasvi",
            group_title: "Distributor",
            patientname: "Dr.Renuka Manish Agarwal ",
            Name: "2025-03-31 10:05:28 AM",
            product_group: "Ligament Brace",
          },
        ],
        totalSales: 6,
        totalPages: 2,
        currentPage: 1,
      },
      error: null,
    };

    if (response.success) {
      return {
        success: true,
        data: response.data.items,
        totalPages: response.data.totalPages,
        currentPage: response.data.currentPage,
        totalCount: response.data.totalSales,
      };
    }
  } catch (error) {
    return console.error("Error fetching sales vs product data ");
  }
};
export const getManageUser = async (searchTerm = "", page = 1, limit = 10) => {
  try {
    const allItems = [
      {
        patientnumber: "9921262361",
        quantity: "1",
        product_name: "1635543000001503688",
        dates: "2025-03-31",
        distributor_name: "Om Sai Healthcare",
        timestamp: "2025-03-31T04:32:40.946346",
        unit_price: "4300",
        record_id: "343275000030960001",
        sales_order_status: "Pending",
        product_code: "Econ Hinged Knee AM OB WA M",
        sales_record_id: "343275000030937017",
        patientemail: "",
        product_id: "1635543000001310603",
        UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
        nickname: "Ravindra Kumarprajapati",
        tracking_status: "Sale",
        category: "sales tracking",
        doctors_name: "343275000004035060",
        username: "ravindrakumarprajapati",
        doctorsname: "Sachin Tapasvi",
        group_title: "Distributor",
        patientname: "Vaibhav Kale ",
        Name: "2025-03-31 10:02:34 AM",
        product_group: "Economy Hinged Knee Brace",
      },
      {
        patientnumber: "9422008826",
        quantity: "1",
        product_name: "1635543000001492005",
        dates: "2025-03-31",
        distributor_name: "Om Sai Healthcare",
        timestamp: "2025-03-31T04:34:37.488234",
        unit_price: "13500",
        record_id: "343275000030898049",
        sales_order_status: "Pending",
        product_code: "Freestyle OA Med RT M",
        sales_record_id: "343275000030935012",
        patientemail: "",
        product_id: "1635543000001313306",
        UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
        nickname: "Ravindra Kumarprajapati",
        tracking_status: "Sale",
        category: "sales tracking",
        doctors_name: "343275000004035060",
        username: "ravindrakumarprajapati",
        doctorsname: "Sachin Tapasvi",
        group_title: "Distributor",
        patientname: "Dr. Vidya Gaikawad ",
        Name: "2025-03-31 10:04:32 AM",
        product_group: "Freestyle® OA Knee Brace",
      },
      {
        patientnumber: "9420558773",
        quantity: "1",
        product_name: "1635543000001506081",
        dates: "2025-03-31",
        distributor_name: "Om Sai Healthcare",
        timestamp: "2025-03-31T04:35:32.684273",
        unit_price: "12200",
        record_id: "343275000030953022",
        sales_order_status: "Pending",
        product_code: "Z-13 STD CI RT, S",
        sales_record_id: "343275000030945028",
        patientemail: "a@gmail.com",
        product_id: "1635543000001332616",
        UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
        nickname: "Ravindra Kumarprajapati",
        tracking_status: "Sale",
        category: "sales tracking",
        doctors_name: "343275000004035060",
        username: "ravindrakumarprajapati",
        doctorsname: "Sachin Tapasvi",
        group_title: "Distributor",
        patientname: "Dr.Renuka Manish Agarwal ",
        Name: "2025-03-31 10:05:28 AM",
        product_group: "Ligament Brace",
      },
      {
        patientnumber: "9921262361",
        quantity: "1",
        product_name: "1635543000001503688",
        dates: "2025-03-31",
        distributor_name: "Om Sai Healthcare",
        timestamp: "2025-03-31T04:32:40.946346",
        unit_price: "4300",
        record_id: "343275000030960001",
        sales_order_status: "Pending",
        product_code: "Econ Hinged Knee AM OB WA M",
        sales_record_id: "343275000030937017",
        patientemail: "",
        product_id: "1635543000001310603",
        UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
        nickname: "Ravindra Kumarprajapati",
        tracking_status: "Sale",
        category: "sales tracking",
        doctors_name: "343275000004035060",
        username: "ravindrakumarprajapati",
        doctorsname: "Sachin Tapasvi",
        group_title: "Distributor",
        patientname: "Vaibhav Kale ",
        Name: "2025-03-31 10:02:34 AM",
        product_group: "Economy Hinged Knee Brace",
      },
      {
        patientnumber: "9422008826",
        quantity: "1",
        product_name: "1635543000001492005",
        dates: "2025-03-31",
        distributor_name: "Om Sai Healthcare",
        timestamp: "2025-03-31T04:34:37.488234",
        unit_price: "13500",
        record_id: "343275000030898049",
        sales_order_status: "Pending",
        product_code: "Freestyle OA Med RT M",
        sales_record_id: "343275000030935012",
        patientemail: "",
        product_id: "1635543000001313306",
        UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
        nickname: "Ravindra Kumarprajapati",
        tracking_status: "Sale",
        category: "sales tracking",
        doctors_name: "343275000004035060",
        username: "ravindrakumarprajapati",
        doctorsname: "Sachin Tapasvi",
        group_title: "Distributor",
        patientname: "Dr. Vidya Gaikawad ",
        Name: "2025-03-31 10:04:32 AM",
        product_group: "Freestyle® OA Knee Brace",
      },
      {
        patientnumber: "9420558773",
        quantity: "1",
        product_name: "1635543000001506081",
        dates: "2025-03-31",
        distributor_name: "Om Sai Healthcare",
        timestamp: "2025-03-31T04:35:32.684273",
        unit_price: "12200",
        record_id: "343275000030953022",
        sales_order_status: "Pending",
        product_code: "Z-13 STD CI RT, S",
        sales_record_id: "343275000030945028",
        patientemail: "a@gmail.com",
        product_id: "1635543000001332616",
        UserId: "58d16340-e0e1-709f-e19a-3d2ddc1b5867",
        nickname: "Ravindra Kumarprajapati",
        tracking_status: "Sale",
        category: "sales tracking",
        doctors_name: "343275000004035060",
        username: "ravindrakumarprajapati",
        doctorsname: "Sachin Tapasvi",
        group_title: "Distributor",
        patientname: "Dr.Renuka Manish Agarwal ",
        Name: "2025-03-31 10:05:28 AM",
        product_group: "Ligament Brace",
      },
    ];

    const filteredItems = allItems.filter((item) =>
      item.patientname.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const total = filteredItems.length;
    const totalPages = Math.ceil(total / limit);
    const paginatedItems = filteredItems.slice(
      (page - 1) * limit,
      page * limit
    );

    return {
      success: true,
      data: paginatedItems,
      totalPages,
      currentPage: page,
      totalCount: total,
    };
  } catch (error) {
    console.error("Error fetching sales vs product data", error);
    return {
      success: false,
      message: "Failed to fetch sales product data",
      error,
    };
  }
};

export const addNewUser = async () => {
  return {
    success: true,
    message: "Successfully added",
  };
};
export const editUser = async () => {
  return {
    success: true,
    message: "Successfully added",
  };
};
